module.exports = __webpack_public_path__ + "static/media/site-to-site-forti.01538c4f.jpg";